<template>
    <div
        class="modal fade text-left"
        id="ssn_modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="ssn-modal"
        aria-hidden="true"
        style="z-index:1200"
    >
        <div
            class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
            role="document"
            style="z-index:1060"
        >
            <div class="modal-content" >
                <div class="modal-header">
                    <h4 class="modal-title text-align-center">
                        Update Your SSN
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row justify-content-center">
                        <div class="col-md-10">
                            <div class="form-group">
                                <div class="controls">
                                    <label for="ssn">Enter New SSN</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Update Social Security"
                                        maxlength="11"
                                        id="ssn"
                                        name="ssn"
                                        v-model="userStore.user.ssn"
                                        pattern="[0-9]{3}-[0-9]{2}-[0-9]{4}"
                                        data-validation-required-message="This ssn field is required"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <p class="modal-title justify-content-center">
                        <strong>
                            Your SSN data is securely stored with AES-256 bit encryption.
                        </strong>
                    </p>
                </div>
                <div class="modal-footer">
                    <div class="col-12 d-flex flex-sm-row flex-column justify-content-center">
                        <button @click="updateSsn()" class="btn btn-primary mr-sm-1 mb-1 mb-sm-0">
                            <i class="fa fa-lock"></i>
                            Securely Save SSN
                        </button>
                        <button type="button" data-dismiss="modal" class="btn btn-outline-warning">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import { hideModal } from '../../utilities/_helpers'
    export default {
        mounted() {
        },
        setup() {
            return {
                userStore: useUserStore(),
                hideModal: hideModal
            }
        },
        methods:{
            updateSsn() {
                let client = this.$route.params.client;
                if(this.$route.name == 'client-dashboard-detail') {
                    client = this.userStore.user.id;
                }
                const $this = this,
                route = $this.$router.resolve(
                    {
                        name: 'update-ssn',
                        params: {
                            client: client,
                            team: $this.$route.params.team
                        }
                    }
                );
                axios.put(
                    route.href,
                    {
                        ssn: $this.userStore.user.ssn
                    }
                ).then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    hideModal('#ssn_modal');
                    toastr.success(response.data.message, 'Success!');
                    return;
                }).catch(function(error) {
                    toastr.error(error.response.data.response_msg, 'Error!');
                });
            }
        }
    }
</script>
